/**
 * Created by Omar Jaime Bonilla Venegas on 2017-06-23.
 * Provides general components for this container
 */
import Item from './item';

export { Item };



// WEBPACK FOOTER //
// ./containers/reportes/components/index.js